var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('check-in-screen',[_c('div',{staticClass:"text-center"},[_c('h2',[_vm._v(_vm._s(_vm.$t('thanks.title')))]),_c('hr'),_c('h4',[_vm._v(_vm._s(_vm.$t('thanks.messageText')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }